import React from 'react';
import styles from './FragmentAndTemplateQuestionSection.module.css';
import classNames from 'classnames';
import FragmentMeasurements from '@modules/Steps/Components/Step1/TemplateMeasurements/FragmentAndTemplateQuestionSection/FragmentMeasurments/FragmentMeasurements';
import { TemplateEntity } from '@entities/Template/Types';
import { FragmentEntity } from '@entities/Fragment/Types';
import DropdownButton from '@shared/Ui/Buttons/DropdownButton/DropdownButton';

interface FragmentSectionProps {
    fragment?: FragmentEntity;
    template?: TemplateEntity;
}

const FragmentAndTemplateQuestionSection: React.FC<FragmentSectionProps> = ({
    fragment,
    template,
}) => {
    const [isExpanded, setIsExpanded] = React.useState<boolean>(true);
    const toggleExpand = () => {
        setIsExpanded(prevState => !prevState);
    };

    const title = fragment ? fragment.title : 'Required Information';

    return (
        <section className={styles.section}>
            <div
                onClick={toggleExpand}
                className={classNames(styles.fragmentSection)}
            >
                <div>{title}</div>
                <DropdownButton
                    isOpen={isExpanded}
                    extraClassName={styles.btn}
                    iconStroke={'#7F7F7F'}
                    iconFill={'#7F7F7F'}
                />
            </div>

            <div
                className={classNames(styles.measurementsContainer, {
                    [styles.expanded]: isExpanded,
                })}
            >
                {fragment && (
                    <FragmentMeasurements questions={fragment.questions} />
                )}
                {template && (
                    <FragmentMeasurements questions={template.questions} />
                )}
            </div>
        </section>
    );
};

export default FragmentAndTemplateQuestionSection;
